"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importStar(require("styled-components"));
var react_intl_1 = require("react-intl");
var uuid_1 = __importDefault(require("uuid"));
var api_1 = require("api");
var components_1 = require("components");
var Banner_1 = __importDefault(require("./components/Banner"));
var Configuration_1 = __importDefault(require("./components/Configuration"));
var CameraControls_1 = __importDefault(require("./components/CameraControls"));
var Footer_1 = __importDefault(require("./components/Footer"));
var Summary_1 = __importDefault(require("./components/Summary"));
var GenericDialog_1 = __importDefault(require("./components/GenericDialog"));
//import Compositor from './components/Compositor';
var ToastContainer_1 = __importDefault(require("./components/ToastContainer"));
var ActionTypes_1 = require("./ActionTypes");
var libzl_1 = require("./libzl");
var tagging_1 = require("./utils/tagging");
var PreloadEnvironments_1 = __importDefault(require("./PreloadEnvironments"));
var WorkIndicator_1 = __importDefault(require("./components/WorkIndicator"));
var IdleIndicator_1 = __importDefault(require("./components/IdleIndicator"));
var ErrorIndicator_1 = __importDefault(require("./components/ErrorIndicator"));
var RichDataIndicator_1 = __importDefault(require("./components/RichDataIndicator"));
var utils_1 = require("./utils");
var auth_1 = require("./utils/auth");
var COMING_SOON = (process.env.REACT_APP_COMING_SOON || "").split(",").map(function (sku) { return sku.toLowerCase(); });
var userId = uuid_1.default.v4();
var MobileOnly = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\topacity: 0;\n\t@media ", " {\n\t\topacity: 1;\n\t\tz-index: 850;\n\t}\n\ttransition: opacity 0.001s linear;\n\tposition: fixed;\n\tbottom: 20%;\n\tleft: 0;\n\tright: 0;\n"], ["\n\topacity: 0;\n\t@media ", " {\n\t\topacity: 1;\n\t\tz-index: 850;\n\t}\n\ttransition: opacity 0.001s linear;\n\tposition: fixed;\n\tbottom: 20%;\n\tleft: 0;\n\tright: 0;\n"])), function (props) { return props.theme.breakpoints.fullScreenStream; });
var StreamingPanel = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpointer-events: all;\n\theight: 100%;\n\tposition: relative;\n\tbackground-color: \"#e7e7e7\";\n\tflex-grow: 1;\n\tflex-shrink: 1;\n"], ["\n\tpointer-events: all;\n\theight: 100%;\n\tposition: relative;\n\tbackground-color: \"#e7e7e7\";\n\tflex-grow: 1;\n\tflex-shrink: 1;\n"])));
var StreamSlider = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", ";\n\n\tmargin-right: ", "px;\n\tmargin-left: ", "px;\n\t\n\t@media (prefers-reduced-motion: no-preference) {\n\t\ttransition: margin-left 0.5s ease-in-out, margin-right 0.5s ease-in-out;\n\t}\n\t\n\twidth: 100%;\n\theight: 100%;\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tmargin: 0;\n\t}\n\n"], ["\n\t", ";\n\n\tmargin-right: ", "px;\n\tmargin-left: ", "px;\n\t\n\t@media (prefers-reduced-motion: no-preference) {\n\t\ttransition: margin-left 0.5s ease-in-out, margin-right 0.5s ease-in-out;\n\t}\n\t\n\twidth: 100%;\n\theight: 100%;\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tmargin: 0;\n\t}\n\n"])), function (props) { return props.hide && "display: none;"; }, function (props) { return props.slide; }, function (props) { return -props.slide; }, function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; });
var FooterPanel = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\n\tpointer-events: all;\n\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: ", "px;\n\n\t@media (prefers-reduced-motion: no-preference) {\n\t\ttransition: right 0.5s ease-in-out;\n\t}\n\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tposition: relative;\n\t\tright: 0;\n\t\t\n\t\t@media (prefers-reduced-motion: no-preference) {\n\t\t\ttransition: none;\n\t\t}\n\t}\n"], ["\n\t\n\tpointer-events: all;\n\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: ", "px;\n\n\t@media (prefers-reduced-motion: no-preference) {\n\t\ttransition: right 0.5s ease-in-out;\n\t}\n\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tposition: relative;\n\t\tright: 0;\n\t\t\n\t\t@media (prefers-reduced-motion: no-preference) {\n\t\t\ttransition: none;\n\t\t}\n\t}\n"])), function (props) { return 100 + props.targetWidth; }, function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; });
var SummaryContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tz-index: 100;\n\tposition: relative;\n\tpointer-events: all;\n\toverflow-y: auto;\n\tbackground-color: white;\n\t-webkit-overflow-scrolling: touch;\n\t\n\t@media not ", " {\n\t\t/*scrollbar already hidden as possible without causing other issues on mobile*/\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n"], ["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tz-index: 100;\n\tposition: relative;\n\tpointer-events: all;\n\toverflow-y: auto;\n\tbackground-color: white;\n\t-webkit-overflow-scrolling: touch;\n\t\n\t@media not ", " {\n\t\t/*scrollbar already hidden as possible without causing other issues on mobile*/\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n"])), function (props) { return props.theme.breakpoints.S; });
var NoPrint = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t@media only print {\n\t\tdisplay: none;\n\t}\n"], ["\n\t@media only print {\n\t\tdisplay: none;\n\t}\n"])));
var OnlyPrint = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tdisplay: none;\n\t@media only print {\n\t\tdisplay: inherit;\n\t}\n"], ["\n\tdisplay: none;\n\t@media only print {\n\t\tdisplay: inherit;\n\t}\n"])));
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.checkComingSoon = function (prompt) {
            if (prompt === void 0) { prompt = false; }
            if (window.zlurlparams.comingsoon || (window.zlurlparams.comingsoon === undefined && window.zlurlparams.unitid && COMING_SOON.includes(window.zlurlparams.unitid.toLowerCase()))) {
                if (prompt) {
                    _this.setState({
                        genericDialogParams: {
                            title: _this.s("closeDialog.error", "Oops!"),
                            info: _this.s("errors.comingsoon", "Coming Soon"),
                            onClose: _this.closeApp,
                            buttons: [
                                {
                                    label: _this.s("errors.ok", "Exit"),
                                    onClick: _this.closeApp
                                }
                            ]
                        },
                        nozl: true
                    });
                }
                return true;
            }
            return false;
        };
        _this.onResizeSummary = function (size) {
            _this.setState({ summary: size });
        };
        _this.createZLAPI = function () {
            libzl_1.createZLAPI(_this, _this.onZLAPIReady, _this.onStreamConnected, _this.onStreamReconnected, _this.onStreamDisconnected, _this.onError, _this.props.onModeChange, _this.props.theme.selectionHighlightCol);
        };
        _this.s = function (id, defaultStr, params) {
            return utils_1.formatMessage(_this.props.intl, { id: id, defaultMessage: defaultStr ? defaultStr : id }, params ? params : {});
        };
        _this.closeApp = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.buildSession) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.buildSession.close()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (window.location === window.parent.location) {
                            console.log("Since we're not in an iframe, we will navigate back.");
                            window.history.back();
                        }
                        else if (!this.props.buildSession && window.parent) {
                            window.parent.postMessage(JSON.stringify({ event: "brp_close_build" }), "*");
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onOrientationChange = function () {
            if (!_this.state.streamConnected) {
                return;
            }
            if (!window.matchMedia) {
                console.log("onOrientationChange: matchMedia undefined");
                return;
            }
            var landscape = window.matchMedia(_this.props.theme.breakpoints.fullScreenStream).matches;
            console.log("onOrientationChange:", { landscape: landscape });
            if (landscape && !_this.state.shownFullscreenPrompt && _this.fullscreenPromptTimeout === undefined) {
                console.log("onOrientationChange: beginining timeout period");
                _this.fullscreenPromptTimeout = setTimeout(function () {
                    console.log("onOrientationChange: clearing message due to timeout");
                    _this.setState({ shownFullscreenPrompt: true });
                    _this.fullscreenPromptTimeout = undefined;
                }, 5000);
            }
            else if (!landscape && _this.fullscreenPromptTimeout !== undefined) {
                console.log("onOrientationChange: clearing message due to orientation change");
                clearTimeout(_this.fullscreenPromptTimeout);
                _this.fullscreenPromptTimeout = undefined;
                _this.setState({ shownFullscreenPrompt: true });
            }
            if (process.env.REACT_APP_DEDICATED_MOBILE_PORTRAIT_CAMERAS && _this.props.buildSession) {
                libzl_1.setNewPrCodes(_this.props.buildSession.getPRCodes(), false);
            }
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            if (!(prevState.zlapiready && prevState.metadataready && prevState.brpapiready) && (_this.state.zlapiready && _this.state.metadataready && _this.state.brpapiready)) {
                var bs = _this.props.buildSession;
                var mastermodel = libzl_1.getMasterModel(bs.getPlatformId(true), bs.getPackageId(), bs.getModelYear(false));
                if (mastermodel) {
                    var _a = mastermodel.split(" "), manufacturer = _a[0], model = _a[1], year = _a[2];
                    _this.onSelectMasterModel(manufacturer, model, year);
                }
                else {
                    _this.onValidateFailed("Missing Master Model");
                }
            }
            if (prevProps.streamingEnvInfo.mastermodel === undefined && _this.props.streamingEnvInfo.mastermodel !== undefined) {
                _this.validateConnectionParams(function (error, response) {
                    if (error) {
                        _this.onValidateFailed(error.message, error);
                    }
                    else {
                        console.log("Validate response: " + JSON.stringify(response));
                        if (response.status === 'valid') {
                            _this.setState({ streamValidateDone: true });
                        }
                        else {
                            console.log("Validate returned " + response.status + " : " + JSON.stringify(response.reason));
                            var failure = {
                                action: "debugerror",
                                item: { error: "Validate failed, reason: " + response.reason }
                            };
                            _this.props.AddToast(failure);
                            _this.onValidateFailed(response.reason);
                        }
                    }
                });
            }
            if (_this.props.buildSession) {
                if (!prevProps.buildSession || (prevProps.uiblacklist !== _this.props.uiblacklist) || (prevProps.availableIn3D !== _this.props.availableIn3D) || (prevProps.ignoreAttachPoints !== _this.props.ignoreAttachPoints) || (prevProps.apiDataExtras !== _this.props.apiDataExtras)) {
                    var blacklist = window.zlurlparams.ignoreUIBlacklist ? [] : _this.props.uiblacklist;
                    var priorityList = [];
                    if (_this.props.availableIn3D) {
                        if (Array.isArray(_this.props.availableIn3D)) {
                            priorityList = _this.props.availableIn3D;
                        }
                        else {
                            priorityList = Object.keys(_this.props.availableIn3D);
                        }
                    }
                    _this.props.buildSession.setConfig(blacklist, priorityList, _this.props.ignoreAttachPoints, undefined, _this.props.apiDataExtras);
                }
            }
            if (!(prevState.streamValidateDone && prevState.brpapiready) && (_this.state.streamValidateDone && _this.state.brpapiready)) {
                console.log("Connect Connection params:", _this.state.connectionParams);
                _this.setState(function (state) {
                    return {
                        connectionParams: __assign(__assign({}, state.connectionParams), _this.calculateParams())
                    };
                }, function () {
                    libzl_1.zlConnect(_this.state.connectionParams, function () { }, function (reason) { _this.setState({ streamValidateDone: false }, function () { return _this.onConnectFailed(reason); }); });
                });
            }
            if (prevProps.scenes.available.length === 0 && _this.props.scenes.available.length > 0) {
                // sets the default environment to be the one used for summary/hero shots
                _this.setState({ heroEnv: _this.props.scenes.current });
            }
        };
        _this.closeValidateDialog = function () {
            _this.setState({ nozl: true, genericDialogParams: undefined });
        };
        _this.onValidateFailed = function (reason, details) {
            var _a, _b;
            console.error("onValidateFailed: " + reason, details);
            (_b = (_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.cloudmine) === null || _b === void 0 ? void 0 : _b.event({ type: ["BYOValidateFailed"], data: { reason: reason, details: details } });
            _this.onServiceError();
        };
        _this.onConnectFailed = function (reason, details) {
            var _a, _b;
            console.error("onConnectFailed: " + reason, details);
            (_b = (_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.cloudmine) === null || _b === void 0 ? void 0 : _b.event({ type: ["BYOConnectFailed"], data: { reason: reason, details: details } });
            _this.onServiceError();
        };
        _this.onServiceError = function () {
            _this.setState({
                zlbolt: null,
                libZL: null,
                zlapiready: false,
                genericDialogParams: {
                    info: _this.s("errors.failedvalidate", "Error!"),
                    onClose: _this.closeValidateDialog,
                    buttons: [
                        {
                            label: _this.s("errors.actioncontinue", "Continue"),
                            onClick: _this.closeValidateDialog
                        },
                        {
                            label: _this.s("errors.actiontryagain", "Try again"),
                            onClick: function () {
                                window.location.reload();
                            }
                        }
                    ]
                }
            });
        };
        _this.collectMetadata = function () {
            var setDone = function (success) {
                _this.setState({ metadataready: success });
            };
            libzl_1.collectMetadata(_this.props.UpdateEnvironments, _this.props.UpdateCarThumbs, _this.props.UpdateStreamingEnvironment, setDone);
        };
        _this.onStreamDisconnected = function () {
            _this.setState({ streamConnected: false });
            //this.setState((state) => ({streamConnected: false, nozl: state.nozl || state.streamConnected}));
        };
        _this.onError = function () {
            if (!tagging_1.taggingIsInitialised()) {
                var bs = _this.props.buildSession;
                tagging_1.taggingInit(bs.session.locale, window.zlurlparams.byo_flow, bs.state.uuid, bs.getModelType(), bs.getModelRangeName(false), bs.getPlatformId(), bs.getPackageId(), bs.getMarketingName(), bs.getModelSku(), bs.getModelYear(), bs.getSummary());
            }
        };
        _this.onStreamReconnected = function () {
            console.log("RECONNECTED!");
            _this.setState({ nozl: false, streamConnected: true }, _this.onOrientationChange);
            var bs = _this.props.buildSession;
            var buildcodes = bs.getPRCodes();
            var prcodes = libzl_1.filterNonVisualCodes(bs.getModelRangeName(false), bs.getModelYear(false), buildcodes);
            libzl_1.setNewPrCodes(prcodes);
        };
        _this.onStreamConnected = function () {
            _this.setState({ nozl: false, streamConnected: true }, _this.onOrientationChange);
            var bs = _this.props.buildSession;
            if (!bs) {
                debugger;
            }
            if (!tagging_1.taggingIsInitialised()) {
                tagging_1.taggingInit(bs.session.locale, window.zlurlparams.byo_flow, bs.state.uuid, bs.getModelType(), bs.getModelRangeName(false), bs.getPlatformId(), bs.getPackageId(), bs.getMarketingName(), bs.getModelSku(), bs.getModelYear(), bs.getSummary());
            }
            var buildcodes = bs.getPRCodes();
            var prcodes = libzl_1.filterNonVisualCodes(bs.getModelRangeName(false), bs.getModelYear(false), buildcodes);
            libzl_1.setNewPrCodes(prcodes);
            _this.props.UpdateEnvironment(window.zlbolt.getEnvironment());
            _this.onOrientationChange();
        };
        _this.directConnecting = function () {
            return _this.state.connectionParams["directConnect"] !== undefined;
        };
        _this.calculateParams = function () {
            var car = _this.props.mastermodel;
            var lineup = car.manufacturer;
            var setupPrCodes = [];
            var bs = _this.props.buildSession;
            if (bs !== undefined) {
                lineup = bs.getProductLineUp();
                setupPrCodes = (bs === null || bs === void 0 ? void 0 : bs.getPRCodes()) || [];
                setupPrCodes = libzl_1.filterNonVisualCodes(bs.getModelRangeName(false), bs.getModelYear(false), setupPrCodes);
                setupPrCodes = libzl_1._injectOrientation(libzl_1._injectRemovals(setupPrCodes));
            }
            var scenes = _this.props.scenes.available.filter(function (s) { return libzl_1.isEnvironmentAvailable(s.id); });
            var setupEnvironment = scenes.sort(function (l, r) { return libzl_1.getEnvironmentSortKey(l.id) - libzl_1.getEnvironmentSortKey(r.id); })[0].id;
            return {
                car: car,
                setupPrCodes: setupPrCodes,
                setupEnvironment: setupEnvironment,
                clientApplication: "BRP-configurator-" + lineup,
                clientMarket: bs.getCountryCode()
            };
        };
        _this.validateConnectionParams = function (cb) {
            _this.setState(function (state) {
                return {
                    connectionParams: __assign(__assign({}, state.connectionParams), _this.calculateParams())
                };
            }, function () {
                // the actual validate call doesn't work on direct connections but injecting in the stream source specific params anyway
                if (_this.directConnecting() || window.zlurlparams.cas) {
                    cb(null, { "status": "valid", "spoofed": true });
                }
                else {
                    console.log("Validate Connection params:", _this.state.connectionParams);
                    libzl_1.zlValidate(_this.state.connectionParams, cb);
                }
            });
        };
        _this.onZLAPIReady = function () {
            _this.setState({ zlapiready: true });
        };
        _this.onUpdateBuildSession = function (bs, summary) {
            var _a, _b, _c;
            var changeModel = false;
            var current = (_b = (_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.car;
            if (current) {
                //Check if we need to change model...
                var platformId = bs.getPlatformId(true);
                var packageId = bs.getPackageId();
                var modelYear = bs.getModelYear(false);
                var required = (_c = libzl_1.getMasterModel(platformId, packageId, modelYear)) === null || _c === void 0 ? void 0 : _c.split(" ");
                if (required) {
                    console.log("Checking if we need to change model", current, required);
                    var manufacturer = required[0], model = required[1], year = required[2];
                    if (current.manufacturer !== manufacturer || current.requestedModel !== model || current.year !== year) {
                        _this.onSelectMasterModel(manufacturer, model, year);
                        var prCodes = (bs === null || bs === void 0 ? void 0 : bs.getPRCodes()) || [];
                        prCodes = libzl_1.filterNonVisualCodes(bs.getModelRangeName(false), modelYear, prCodes);
                        libzl_1.changeMasterModel(manufacturer, model, year, prCodes);
                        changeModel = true;
                    }
                }
            }
            _this.props.UpdateBuildSession(bs, summary, changeModel);
        };
        _this.onSelectMasterModel = function (manufacturer, model, year) {
            var carmeta = _this.props.streamingEnvInfo.vehicle[manufacturer + " " + model + " " + year].metadata;
            var sourcedPrcodes = _this.props.streamingEnvInfo.sourcedPrCodes;
            var sourcedArray = [];
            var ignoreAttachPoints = false;
            var aref = "car." + [manufacturer, model, year].join(".");
            if (aref in sourcedPrcodes) {
                sourcedArray = sourcedPrcodes[aref].prcodes;
                if (sourcedPrcodes[aref].useLibrary) {
                    var regex = new RegExp("^car." + sourcedPrcodes[aref].useLibrary);
                    for (var _i = 0, _a = Object.keys(sourcedPrcodes); _i < _a.length; _i++) {
                        var item = _a[_i];
                        if (sourcedPrcodes[item].isLibrary && regex.test(item)) {
                            sourcedArray = sourcedArray.concat(sourcedPrcodes[item].prcodes);
                        }
                    }
                }
                else if (!sourcedPrcodes[aref].isLibrary) {
                    ignoreAttachPoints = true;
                }
            }
            _this.props.UpdateStreamingEnvironment({
                mastermodel: {
                    manufacturer: manufacturer,
                    model: model,
                    year: year
                },
                uiblacklist: (carmeta === null || carmeta === void 0 ? void 0 : carmeta.uiBlacklist) || [],
                apidataextras: carmeta === null || carmeta === void 0 ? void 0 : carmeta.injectAPIData,
                ignoreattachpoints: ignoreAttachPoints
            });
            if (sourcedArray.length) {
                var finalCodes_1 = {};
                sourcedArray.forEach(function (element) {
                    finalCodes_1[element] = {};
                });
                _this.props.SetAllCodes(finalCodes_1);
            }
            else {
                _this.props.SetAllCodes(_this.props.streamingEnvInfo.allAvailablePrcodes);
            }
        };
        _this.toggleSummary = function () {
            var newSize = _this.state.summary > 0 ? 0 : 1.0;
            _this.onResizeSummary(newSize);
            if (newSize > 0) {
                utils_1.ZLTagger.UC05_summary();
                utils_1.ZLTagger.UC07_finished(_this.props.buildSession.getSummary(), "view summary");
            }
        };
        _this.toggleCalc = function () {
            _this.setState(function (state) { return ({ showingCalculator: !state.showingCalculator }); });
        };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            var summary;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.buildSession) return [3 /*break*/, 2];
                        utils_1.ZLTagger.UC06_save();
                        return [4 /*yield*/, this.props.buildSession.save()];
                    case 1:
                        _a.sent();
                        utils_1.ZLTagger.UC07_finished(this.props.buildSession.getSummary(), "save");
                        summary = {
                            action: "savedBuild",
                            item: ""
                        };
                        this.props.AddToast(summary);
                        this.showSavedDialog();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.hideDialog = function () {
            _this.setState({ genericDialogParams: undefined });
        };
        _this.showSavedDialog = function () {
            /*
            if(this.state.shownSaveDialog) {
                return;
            }
            this.setState({shownSaveDialog: true});
    
            let buttons = [
                {
                    label: this.s("savedDialog.getquote", "Get A Quote"),
                    onClick: async () => {
                        if(this.props.buildSession){
                            await this.props.buildSession.getQuote();
                            ZLTagger.UC07_finished(this.props.buildSession.getSummary(), "save + quote");
                        };
                        this.hideDialog();
                    },
                    automationId: "getquote"
                },
                {
                    label: this.s("savedDialog.continue", "Got It"),
                    onClick: () => { this.hideDialog();},
                    automationId: "continue"
                }
    
            ]
    
            this.setState({
                genericDialogParams: {
                    title: this.s("savedDialog.title", "YOUR BUILD HAS BEEN SAVED"),
                    info: this.s("savedDialog.message", "From now on, any change you make will be automatically saved. Come back any time to make changes, or to get an official quote."),
                    buttons,
                    showClose: true,
                    onClose: this.hideDialog
                }
            });
            */
        };
        _this.onConfigurationSizeChange = function (size) {
            _this.setState({ panelWidth: size });
        };
        _this.state = {
            summary: 0,
            libZL: null,
            zlbolt: null,
            connectionParams: libzl_1.getDefaultConnectionParams(),
            zlapiready: false,
            brpapiready: false,
            metadataready: undefined,
            streamValidateDone: false,
            streamConnected: false,
            panelWidth: 0,
            heroEnv: undefined,
            showingCalculator: false,
            genericDialogParams: undefined,
            nozl: false,
            shownFullscreenPrompt: false
        };
        _this.fullscreenPromptTimeout = undefined;
        auth_1.processAuth();
        if (_this.checkComingSoon(false)) {
            return _this;
        }
        window.addEventListener("message", function (ev) {
            var _a;
            var msg = undefined;
            try {
                msg = JSON.parse(ev.data);
            }
            catch (_b) {
            }
            if ((msg === null || msg === void 0 ? void 0 : msg.event) === "byo_populate") {
                if ((_a = msg.params) === null || _a === void 0 ? void 0 : _a.rooturl) {
                    window.zlurlparams.rooturl = msg.params.rooturl;
                }
            }
        });
        window.parent.postMessage(JSON.stringify({ event: "byo_launched" }), "*");
        var locale = window.zlurlparams.locale;
        var currency = window.zlurlparams.currency;
        var api = window.zlurlparams.api;
        var userregion = window.zlurlparams.userregion;
        fetch("/index.json").then(function (response) {
            if (response.ok) {
                return response.text();
            }
            return "";
        }).then(function (data) {
            var json = {};
            try {
                json = JSON.parse(data);
            }
            catch (_a) { }
            _this.props.UpdateStreamingEnvironment({ webpage: json, href: window.location.href });
        });
        _this.createZLAPI();
        var zlservice = window.zlurlparams.shortcodeservice || _this.state.connectionParams.connectionParameters.environment;
        if (["assetpreview", "prelive"].includes(zlservice)) {
            zlservice = "stage";
        }
        console.log("UserID", userId);
        var referrer = document.referrer ? new URL(document.referrer) : null;
        var server = window.zlurlparams.contentdamorigin || ((referrer && window.location !== window.parent.location && window.location.origin !== referrer.origin && !referrer.port) ? referrer.origin : "https://www.brp.ca");
        var sessionid = api_1.StartSession(api, userId, server, "unused", locale, userregion, currency, zlservice);
        console.log("SessionID", sessionid);
        if (window.zlurlparams.invalidParams.length > 0) {
            _this.setState({
                genericDialogParams: {
                    title: _this.s("closeDialog.error", "Oops!"),
                    info: _this.s("errors.badurlparams", "Bad URL params!"),
                    onClose: _this.closeApp,
                    buttons: [
                        {
                            label: _this.s("errors.ok", "Exit"),
                            onClick: _this.closeApp
                        }
                    ]
                }
            });
            return _this;
        }
        var buildId = uuid_1.default.v4();
        var initialData = undefined;
        if (window.zlurlparams.buildid) {
            buildId = window.zlurlparams.buildid;
        }
        else {
            initialData = {
                profileName: window.zlurlparams.profile,
                platformId: window.zlurlparams.platform,
                packageId: window.zlurlparams.package,
                unitId: window.zlurlparams.unitid,
                requiredFeatures: window.zlurlparams.requiredFeatures,
                desiredFeatures: window.zlurlparams.desiredFeatures,
                desiredAccessories: window.zlurlparams.desiredAccessories,
                modelYear: window.zlurlparams.modelyear
            };
        }
        _this.collectMetadata();
        var shortcode = window.zlurlparams.shortcode;
        if (shortcode) {
            _this.props.OnShortCode(undefined, shortcode);
        }
        console.log("StartBuildSession:", { userId: userId, buildId: buildId, initialData: initialData });
        api_1.StartBuildSession(userId, buildId, _this.onUpdateBuildSession, _this.props.OnConflict, _this.props.OnAttachChoice, _this.props.OnShortCode, initialData, shortcode)
            .then(function (buildSession) {
            if (shortcode || window.zlurlparams.buildid) {
                window.zlurlparams.platform = buildSession.getPlatformId();
                window.zlurlparams.package = buildSession.getPackageId();
                window.zlurlparams.modelyear = buildSession.getModelYear(false);
                console.log("Model Params", { platform: window.zlurlparams.platform, package: window.zlurlparams.package, year: window.zlurlparams.modelyear });
            }
            _this.checkComingSoon(true);
            _this.setState({ brpapiready: true });
        })
            .catch(function (reason) {
            var _a, _b;
            console.log("Unable to start build session!", reason);
            //	let errmsg = this.s("errors.rawerror", "Error: {e}", {"e": reason}) as React.ReactNodeArray;
            if (!_this.checkComingSoon(true)) {
                (_b = (_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.cloudmine) === null || _b === void 0 ? void 0 : _b.event({ type: ["BYOAPIFailed"], data: { url: window.location.href } });
                _this.setState({
                    genericDialogParams: {
                        title: _this.s("closeDialog.error", "Oops!"),
                        info: _this.s("errors.failedinit", "Something went wrong!"),
                        onClose: _this.closeApp,
                        buttons: [
                            {
                                label: _this.s("errors.ok", "Exit"),
                                onClick: _this.closeApp
                            }
                        ]
                    }
                });
            }
        });
        return _this;
    }
    Layout.prototype.componentDidMount = function () {
        this.checkComingSoon(true);
    };
    Layout.prototype.render = function () {
        var _a;
        var light = window.zlurlparams.light;
        var showerror = this.state.panelWidth === 0 || (window.matchMedia && window.matchMedia(this.props.theme.breakpoints.S).matches === false);
        var cameras = [
            (_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.movableExteriorCamera,
            "SteeringWheel_L0L" //Don't change back to window.zlbolt?.movableInteriorCamera that camera name is sacrificial to avoid our desired settings being stomped.
        ];
        if (window.zlurlparams.platform.toLowerCase() === "sea_manta") {
            cameras.push("TopDown");
        }
        //showerror = false;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(NoPrint, { style: { height: "100%" } },
                react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', pointerEvents: "none", position: "relative" } },
                    this.props.buildSession &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            !this.state.summary && this.props.buildSession &&
                                react_1.default.createElement("div", { style: { flexGrow: 0, flexShrink: 0, pointerEvents: "all", zIndex: 250 } },
                                    react_1.default.createElement(Banner_1.default, { closeApp: this.closeApp, doSave: this.save, norenderservice: this.state.nozl || !(window.zlbolt && window.zlbolt.streamIsActive) })),
                            react_1.default.createElement(Configuration_1.default, { apiready: this.state.brpapiready, onSizeChange: this.onConfigurationSizeChange, hide: this.state.summary !== 0, connected: this.state.streamConnected },
                                react_1.default.createElement(StreamingPanel, null,
                                    react_1.default.createElement("div", { style: { position: 'absolute', left: 0, top: 0, bottom: 0, right: 0, zIndex: 500, pointerEvents: "none" } },
                                        react_1.default.createElement(ToastContainer_1.default, null)),
                                    react_1.default.createElement(StreamSlider, { slide: this.state.panelWidth / 2, hide: this.state.nozl },
                                        react_1.default.createElement(WorkIndicator_1.default, { zlbolt: window.zlbolt }),
                                        react_1.default.createElement(IdleIndicator_1.default, { zlbolt: window.zlbolt }),
                                        window.zlurlparams.capturediv &&
                                            react_1.default.createElement("div", { id: "capturediv", style: { zIndex: 50, pointerEvents: "none", position: "absolute", left: "13%", top: "5%", width: "62%", height: "87%", border: "1px solid rgba(255,0,0,0.5)" } }),
                                        react_1.default.createElement(components_1.StreamContainer, { id: "streamContainer" }, /*window.zlurlparams.localstream &&*/ /* only for dev for now */ react_1.default.createElement(RichDataIndicator_1.default, { zlbolt: window.zlbolt })),
                                        !this.state.shownFullscreenPrompt && this.state.streamConnected &&
                                            react_1.default.createElement(MobileOnly, { onTransitionEnd: this.onOrientationChange },
                                                react_1.default.createElement(components_1.Message, { closable: true }, this.s("mobilefullscreen.prompt", "Tilt device to exit full screen view")))),
                                    (this.state.nozl && showerror) &&
                                        react_1.default.createElement(StreamSlider, { slide: this.state.panelWidth / 2 },
                                            react_1.default.createElement(ErrorIndicator_1.default, { bgimg: this.props.buildSession.getDefaultMarketingImage() })),
                                    (this.state.summary === 0) &&
                                        react_1.default.createElement("div", { style: { position: 'absolute', left: 0, top: 0, pointerEvents: "all" } }, this.state.streamConnected &&
                                            react_1.default.createElement(CameraControls_1.default, { cameras: cameras, split: true })))),
                            !this.state.summary &&
                                react_1.default.createElement(styled_components_1.ThemeProvider, { theme: __assign(__assign({}, (light ? this.props.theme.themes.alt : this.props.theme.themes.main)), { themes: this.props.theme.themes }) },
                                    react_1.default.createElement(FooterPanel, { targetWidth: this.state.panelWidth },
                                        react_1.default.createElement(Footer_1.default, { doToggleSummary: this.toggleSummary, doToggleCalc: this.toggleCalc, doSave: this.save, showCalculator: this.state.showingCalculator }))),
                            this.state.summary !== 0 &&
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("div", { style: { flexGrow: 0, flexShrink: 0, zIndex: 100, pointerEvents: "all", backgroundColor: 'white' } },
                                        react_1.default.createElement(Footer_1.default, { doToggleSummary: this.toggleSummary, doToggleCalc: this.toggleCalc, showingSummary: true, doSave: this.save, showCalculator: this.state.showingCalculator })),
                                    react_1.default.createElement(SummaryContainer, { role: "main" },
                                        react_1.default.createElement(Summary_1.default, { imageEnv: this.state.heroEnv, size: this.state.summary, onResize: this.onResizeSummary, doToggleCalc: this.toggleCalc })))),
                    this.state.genericDialogParams &&
                        react_1.default.createElement(GenericDialog_1.default, __assign({}, this.state.genericDialogParams)),
                    react_1.default.createElement(PreloadEnvironments_1.default, null))),
            react_1.default.createElement(OnlyPrint, { style: { height: "100%" } },
                react_1.default.createElement(Summary_1.default, { imageEnv: this.state.heroEnv, size: this.state.summary, onResize: this.onResizeSummary, doToggleCalc: this.toggleCalc }))));
    };
    return Layout;
}(react_1.Component));
var mapDispatchToProps = function (dispatch /*, ownProps: any*/) {
    return {
        AddToast: function (summary) { return dispatch({
            type: ActionTypes_1.ADD_TOAST,
            summary: summary
        }); },
        UpdateBuildSession: function (bs, summary, changeModel) {
            console.log("BuildSession", bs);
            var prcodes = libzl_1.filterNonVisualCodes(bs.getModelRangeName(false), bs.getModelYear(false), bs.getPRCodes());
            if (tagging_1.taggingIsInitialised()) {
                if (!changeModel) {
                    libzl_1.setNewPrCodes(prcodes);
                }
                tagging_1.taggingUpdateModelInfo(bs.getModelSku(), bs.getMarketingName());
                window.zltagger.updateBuild(bs, summary);
            }
            return dispatch({
                type: ActionTypes_1.UPDATE_BUILD_SESSION,
                data: bs,
                summary: summary,
                activecodes: prcodes
            });
        },
        OnConflict: function (details) { return dispatch({
            type: ActionTypes_1.ON_CONFLICT,
            data: details
        }); },
        OnAttachChoice: function (details) { return dispatch({
            type: ActionTypes_1.ON_ATTACH_CHOICE,
            data: details
        }); },
        OnShortCode: function (_, shortcode) {
            console.log("Shortcode: " + shortcode);
            return dispatch({
                type: ActionTypes_1.ON_SHORT_CODE,
                data: shortcode
            });
        },
        UpdateEnvironment: function (current) {
            tagging_1.taggingUpdateEnvironment(current);
            dispatch({
                type: ActionTypes_1.UPDATE_ENVIRONMENT,
                data: current
            });
        },
        UpdateEnvironments: function (environments) {
            dispatch({
                type: ActionTypes_1.UPDATE_ENVIRONMENTS,
                data: {
                    environments: environments
                }
            });
        },
        UpdateCarThumbs: function (thumbData, masterLibrary) { return dispatch({
            type: ActionTypes_1.UPDATE_THUMBS,
            data: {
                thumbData: thumbData,
                masterLibrary: masterLibrary
            }
        }); },
        SetAllCodes: function (allcodes) { return dispatch({
            type: ActionTypes_1.SET_ALL_CODES,
            data: allcodes
        }); },
        UpdateStreamingEnvironment: function (environmentData) { return dispatch({
            type: ActionTypes_1.UPDATE_STREAMING_ENVIRONMENT,
            data: environmentData
        }); },
        onModeChange: function (target, pending) { return dispatch({
            type: ActionTypes_1.UPDATE_MODE,
            data: { target: target, pending: pending }
        }); }
    };
};
var MapStoreToProps = function (store /*, ownProps:any*/) {
    return {
        mastermodel: store.EnvironmentInfo.mastermodel,
        streamingEnvInfo: store.EnvironmentInfo,
        scenes: store.UI.environments,
        buildSession: store.BuildSession.current,
        availableIn3D: store.UI.allcodes,
        uiblacklist: store.EnvironmentInfo.uiblacklist,
        ignoreAttachPoints: store.EnvironmentInfo.ignoreattachpoints,
        apiDataExtras: store.EnvironmentInfo.apidataextras
    };
};
exports.default = react_redux_1.connect(MapStoreToProps, mapDispatchToProps)(styled_components_1.withTheme(react_intl_1.injectIntl(Layout)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Layout.js.map